import type {UuidDTO} from '@/ts/types/dto/sign-in-dto';
import type {
  Option,
  QuestionMultiChoice,
} from '@/ts/types/dto/interventions-dto';

/** Resolves the numeric value for a slider question from the current model, previous answer, or default option */
export function calculateNumber(options: Option[], model: UuidDTO[] | undefined, question: QuestionMultiChoice): number | null {
  function idToValue(input: UuidDTO[]): number | null {
    return options.find(op => op.id === input[0])?.value ?? null;
  }

  if (model?.[0]) {
    return idToValue(model);
  }
  if (question.multiChoiceSelectedIds && question.multiChoiceSelectedIds.length > 0) {
    return idToValue(question.multiChoiceSelectedIds);
  }
  const defaultId = options.find(op => op.defaultAnswer);
  if (defaultId) {
    return defaultId.value;
  }
  return null;
}
